"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTypeString = exports.toNumber = exports.remove = exports.percentage = exports.objectToString = exports.moneyFormat = exports.kebabCase2PascalCase = exports.isUrl = exports.isSymbol = exports.isString = exports.isSet = exports.isPromise = exports.isPlainObject = exports.isOn = exports.isObject = exports.isModelListener = exports.isMap = exports.isFunction = exports.isDate = exports.isArray = exports.hyphenate = exports.hasOwn = exports.hasChanged = exports.extend = exports.def = exports.convertLevelShopsByUser = exports.convertLevelShopData = exports.NOOP = exports.NO = void 0;
require("core-js/modules/es.array.push.js");
const NOOP = () => {};

/**
 * Always return false.
 */
exports.NOOP = NOOP;
const NO = () => false;
exports.NO = NO;
const onRE = /^on[^a-z]/;
const isOn = key => onRE.test(key);
exports.isOn = isOn;
const isModelListener = key => key.startsWith('onUpdate:');
exports.isModelListener = isModelListener;
const extend = exports.extend = Object.assign;
const remove = (arr, el) => {
  const i = arr.indexOf(el);
  if (i > -1) {
    arr.splice(i, 1);
  }
};
exports.remove = remove;
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn = (obj, prop) => {
  return hasOwnProperty.call(obj, prop);
};
exports.hasOwn = hasOwn;
const isArray = exports.isArray = Array.isArray;
const objectToString = exports.objectToString = Object.prototype.toString;
const toTypeString = value => objectToString.call(value);
exports.toTypeString = toTypeString;
const isMap = val => toTypeString(val) === '[object Map]';
exports.isMap = isMap;
const isSet = val => toTypeString(val) === '[object Set]';
exports.isSet = isSet;
const isDate = val => val instanceof Date;
exports.isDate = isDate;
const isFunction = val => typeof val === 'function';
exports.isFunction = isFunction;
const isString = val => typeof val === 'string';
exports.isString = isString;
const isSymbol = val => typeof val === 'symbol';
exports.isSymbol = isSymbol;
const isObject = val => val !== null && typeof val === 'object';
exports.isObject = isObject;
const isPromise = val => {
  return isObject(val) && isFunction(val.then) && isFunction(val.catch);
};
exports.isPromise = isPromise;
const isPlainObject = val => toTypeString(val) === '[object Object]';

// compare whether a value has changed, accounting for NaN.
exports.isPlainObject = isPlainObject;
const hasChanged = (value, oldValue) => !Object.is(value, oldValue);

// 用连字号连接 PascalCase转kebab-case
exports.hasChanged = hasChanged;
const hyphenate = str => {
  const hyphenateRE = /([a-z\d])([A-Z])/g;
  return str.replace(hyphenateRE, '$1-$2').toLowerCase();
};

// kebab-case转PascalCase
exports.hyphenate = hyphenate;
const kebabCase2PascalCase = str => {
  return `-${str}`.replace(/-(\w)/g, ($, $1) => {
    return $1.toUpperCase();
  });
};
exports.kebabCase2PascalCase = kebabCase2PascalCase;
const isUrl = url => {
  return /^(((ht|f)tps?):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(url);
};
exports.isUrl = isUrl;
const def = (obj, key, value) => {
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: false,
    value
  });
};
exports.def = def;
const toNumber = val => {
  const n = parseFloat(val);
  return isNaN(n) ? val : n;
};

// 格式化 金钱，默认保留两位
exports.toNumber = toNumber;
const moneyFormat = (money, fractionDigits = 2) => {
  const _money = parseFloat(money);
  if (!isNaN(_money)) {
    return _money.toFixed(fractionDigits);
  }
  const z = 0;
  return z.toFixed(fractionDigits);
};

// percentage
exports.moneyFormat = moneyFormat;
const percentage = (x, y, symbol = '%') => {
  if (x === '' || y === '') return '--';
  if (y === 0) return '0%';
  let number = x / y * 100;
  number = Math.round(number);
  if (!isNaN(number)) {
    return `${number}${symbol}`;
  }
  return '0%';
};
exports.percentage = percentage;
const convertLevelShopData = (list, _fn) => {
  _.each(list, li => {
    li._isTop = true;
  });
  const traverse = items => {
    for (const item of items) {
      // concat children and shops
      item._children = _.concat(item.children || [], item.shops || []);
      item._title = item.bizName || item.shopName;
      item._value = item.bizId || item.shopNo;
      // 给层级注入可修改的时机
      !!_fn && _fn('Biz', item);
      _.each(item.shops, shop => {
        shop._title = shop.shopName;
        shop._value = shop.shopNo;
        // 给店铺注入可修改的时机
        !!_fn && _fn('Shop', shop);
      });
      if (_.size(item.children)) {
        traverse(item.children);
      }
    }
  };
  traverse(list);
  return list;
};
exports.convertLevelShopData = convertLevelShopData;
const convertLevelShopsByUser = (userInfo, bizLevelShops, sign = 'power') => {
  const {
    shopNos,
    id
  } = userInfo;
  const list = [];
  const traverse = items => {
    for (const item of items) {
      _.each(item.shops, shop => {
        list.push(shop);
      });
      if (_.size(item.children)) {
        traverse(item.children);
      }
    }
  };
  traverse(bizLevelShops);
  const arr = shopNos.split(',');
  if (arr.length > 0) {
    return list.filter(item => arr.includes(item.shopNo)).map(item => {
      return {
        ...item,
        [sign]: id === item.userId
      };
    });
  }
  return [];
};
exports.convertLevelShopsByUser = convertLevelShopsByUser;